import React from 'react';
import {WorkerAppNavBar} from "./mainframe/WorkerAppNavbar";
import {Route, Switch as RouterSwitch} from 'react-router-dom';
import {makeStyles} from "@material-ui/core/styles";
import {WorkerWelcomeScreen} from "./workerWelcomeScreen/WorkerWelcomeScreen";
import {WorkerPersonalDataScreen} from "./workerPersonalData/WorkerPersonalDataScreen";
import {useInitializeServices} from "../services/redux/services.hook";
import {WorkerCalendarScreen} from "../workers/screens/worker/WorkerCalendar.screen.";
import {WorkerOrderScreen} from "./order/WorkerOrder.screen";
import {WorkerScheduleScreen} from "./schedule/WorkerScheduleScreen";
import {NoServicesAlert} from "./workerPersonalData/NoServicesAlert";
import {InitialChangePassword} from "./InitialChangePassword";
import {OrderFinalizationAlert} from "./order/OrderFinalizationAlert";

const useStyles = makeStyles((theme) => ({
    workerAppContainer: {
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing(2),
        minHeight: "100vh"
    }
}));

export function WorkerApp() {
    useInitializeServices();
    const classes = useStyles();
    return (
        <div>
            <WorkerAppNavBar/>
            <NoServicesAlert/>
            <OrderFinalizationAlert/>
            <main className={classes.workerAppContainer}>
                <InitialChangePassword>
                    <RouterSwitch>
                        <Route exact path={"/worker"}>
                            <WorkerWelcomeScreen/>
                        </Route>
                        <Route path={"/worker/calendar"}>
                            <WorkerCalendarScreen/>
                        </Route>
                        <Route path={"/worker/personal-data"}>
                            <WorkerPersonalDataScreen/>
                        </Route>
                        <Route path={"/worker/order/:orderId"}>
                            <WorkerOrderScreen/>
                        </Route>
                        <Route path={"/worker/schedule"}>
                            <WorkerScheduleScreen/>
                        </Route>
                    </RouterSwitch>
                </InitialChangePassword>
            </main>
        </div>
    );
}
